import { useEvents } from '@/hooks/useEvents';
import { formatEventDayLabel, formatEventTimeRange } from '@shared/events';
import { LAGOA_AGENDA_SOURCE, LAGOA_AGENDA_URL } from '@shared/lagoaAgenda';
import { appendEnglish } from '@shared/ptEn';
import { Bilingual } from '@/components/Bilingual';
import { FixTranslation } from '@/components/FixTranslation';

export function EventsPage() {
  const { today, events, loading, applyTitleEnglish } = useEvents();

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">What’s On</h1>
        <p className="page-subtitle">
          <a href={LAGOA_AGENDA_URL} target="_blank" rel="noreferrer">
            <Bilingual text={LAGOA_AGENDA_SOURCE} />
          </a>
        </p>
      </div>
      {loading && <div className="skeleton" style={{ height: 80 }} />}
      {!loading && events.length === 0 && <p className="empty-state">No events loaded yet</p>}
      {today &&
        events.map((e) => (
          <article key={e.id} id={`event-${e.id}`} className="card">
            <h2>
              <Bilingual text={e.title} english={e.titleEn} />
            </h2>
            <FixTranslation title={e.title} onFixed={(english) => applyTitleEnglish(e.title, english)} />
            <p className="muted">
              {formatEventDayLabel(e.date, today)}
              {formatEventTimeRange(e) ? ` · ${formatEventTimeRange(e)}` : ''}
              {e.location ? ` · ${appendEnglish(e.location, e.location)}` : ''}
            </p>
            {e.notes && <p style={{ marginTop: 8 }}>{e.notes}</p>}
            <p className="event-source">
              {e.url ? (
                <a href={e.url} target="_blank" rel="noreferrer">
                  <Bilingual text={e.source ?? LAGOA_AGENDA_SOURCE} />
                </a>
              ) : (
                <Bilingual text={e.source ?? LAGOA_AGENDA_SOURCE} />
              )}
            </p>
          </article>
        ))}
    </div>
  );
}
